import React, { useEffect, useState } from "react";

const KEY = "nk-cookie-consent";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "accepted");
    setShow(false);
  };
  const decline = () => {
    localStorage.setItem(KEY, "declined");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="cookie-banner" data-testid="cookie-banner" role="dialog" aria-label="Cookie consent">
      <p className="text-[13px] text-[var(--text)]/85 flex-1 font-light leading-relaxed">
        We use cookies to understand which brands and platforms you love most.
        See our{" "}
        <a href="#" className="text-gold underline-offset-2 hover:underline">
          privacy policy
        </a>
        .
      </p>
      <div className="flex gap-2">
        <button
          onClick={decline}
          className="btn-ghost"
          style={{ padding: "10px 18px", fontSize: "11px" }}
          data-testid="cookie-decline"
        >
          Decline
        </button>
        <button
          onClick={accept}
          className="btn-primary"
          style={{ padding: "10px 18px", fontSize: "11px" }}
          data-testid="cookie-accept"
        >
          Accept
        </button>
      </div>
    </div>
  );
}
